import { checkResponse } from "src/components/js/statics1";
import betoniClass from "./betoniClass";
import { keikkaBetoni_cacheName, cache_clear } from "src/components/js/CacheFunctions";
import { socketOnSave } from "../system/socketClass";

// use this when keikkaData is shallow copied (eg. from keikkaData is origKeikkaData)
export function keikkaBetoni_getBetoni_from_keikkaData_by_keikkaBetoniId(
  keikkaData,
  keikkaBetoniId
) {
  if (keikkaData.keikkaData) keikkaData = keikkaData.keikkaData;
  let betoni = null;
  if (keikkaData.betoni) {
    betoni = keikkaData.betoni.find((b) => b.keikkaBetoniId === keikkaBetoniId);
  }
  if (!betoni) betoni = keikkaData.betoni[0];
  return betoni;
}
export async function keikkaBetoni_createSingle(keikkaId, token) {
  cache_clear(keikkaBetoni_cacheName);
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      keikkaId: keikkaId,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/keikka/betoni/new",
    requestOptions
  );
  const cResponse = await checkResponse(response, "keikkaClass.js:addNewBetoni");
  if (!cResponse.success) {
    console.log(cResponse);
    return false;
  }
  const keikkaBetoniId = cResponse.data.returnValue;
  return keikkaBetoniId;
}

export async function keikkaBetoni_createToKeikka(keikkaData, token, socket, personId) {
  cache_clear(keikkaBetoni_cacheName);
  const keikkaId = keikkaData.keikkaId;
  const keikkaBetoniId = await keikkaBetoni_createSingle(keikkaId, token);
  const _betoni = new betoniClass();
  _betoni.keikkaBetoniId = keikkaBetoniId;
  keikkaData.betoni.push(_betoni);

  // send socket event
  const s = new socketOnSave(personId, socket, null, "keikkaData", "save", keikkaId);
  s.keikkaId = keikkaId;
  s.keikkaData = keikkaData;
  s.emitSave();

  return keikkaBetoniId;
}

export async function keikkaBetoni_delete_from_db(
  keikkaBetoniId,
  token,
  socket = null,
  keikkaId = null,
  personId = null
) {
  cache_clear(keikkaBetoni_cacheName);
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      keikkaBetoniId: keikkaBetoniId,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/keikka/betoni/delete",
    requestOptions
  ).catch((error) => {
    console.log(error);
    return false;
  });
  if (!(await checkResponse(response)).success) return false;

  // send socket event
  const s = new socketOnSave(personId, socket, null, "betoni", "delete", keikkaId);
  s.keikkaData.keikkaBetoniId = keikkaBetoniId;
  s.emitSave();

  return true;
}

export async function keikkaBetoni_copy(keikkaId, keikkaBetoniId, token, socket, personId) {
  cache_clear(keikkaBetoni_cacheName);
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      keikkaBetoniId: keikkaBetoniId, // source betoni
      keikkaId: keikkaId, // target keikka
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/keikka/betoni/copy",
    requestOptions
  )
    .then((response) => {
      if (!response.ok) {
        throw Error("Copy failed");
      }
      return response;
    })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((error) => {
      throw Error(error);
    });

  // send socket event
  const s = new socketOnSave(personId, socket, null, "betoni", "copy", keikkaId);
  s.keikkaData.keikkaBetoniId = response.returnValue;
  s.emitSave();

  console.log(response);
  return response;
}

export async function keikkaBetoni_switchBetoniOrder(
  keikkaId,
  keikkaBetoniId1,
  keikkaBetoniId2,
  token,
  socket,
  personId
) {
  cache_clear(keikkaBetoni_cacheName);
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      keikkaBetoniId1: keikkaBetoniId1,
      keikkaBetoniId2: keikkaBetoniId2,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/keikka/betoni/switchOrder",
    requestOptions
  )
    .then((response) => {
      if (!response.ok) {
        throw Error("Switch failed");
      }
      return response;
    })
    .catch((error) => {
      throw Error(error);
    });

  // send socket event
  const s = new socketOnSave(personId, socket, null, "betoni", "switch", keikkaId);
  s.keikkaData.keikkaBetoniId = response.returnValue;
  s.emitSave();

  return response;
}
